<template>
  <div class="reports">

    <el-row>
      <div class="panelheader">
        <div class="title">
          {{ pageName }}
        </div>
      </div>

      <div class="body">
        <el-row type="flex" justify="space-between">
          <el-col :span="6">
            <el-select
              v-model="displayFields"
              placeholder="Select some fields"
              multiple
              collapse-tags
            >

              <el-option-group
                v-for="site in sites"
                :key="site.id"
                :label="site.name"
              >

                <el-option
                  v-for="field in site.fields"
                  :key="field.id"
                  :value="field.id"
                  :label="field.field_name"
                />

              </el-option-group>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="displayClubs"
              placeholder="Select club(s)"
              multiple
              collapse-tags
            >
              <el-option
                v-for="club in clubs"
                :key="club.id"
                :value="club.name"
                :label="club.name"
              />
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              unlink-panels
              :picker-options="datePickerOptions"
            />
          </el-col>
        </el-row>

        <!-- <el-row :gutter="10">
          <el-col :span="24">
            <fields-consumption
              :displayFields="displayFields"
              :displayClubs="displayClubs"
              :dateRange="formatDR"
            />
          </el-col>

        </el-row> -->

        <el-row>
          <el-col :span="24">
            <fields-time
              :displayFields="displayFields"
              :dateRange="formatDR"
            />
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <user-actions
              :displayFields="displayFields"
              :dateRange="formatDR"/>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <lights-table
              :displayFields="displayFields"
              :dateRange="formatDR"/>
          </el-col>
        </el-row>

      </div>

    </el-row>
  </div>
</template>

<script>
import FieldsConsumption from './reports/FieldsConsumption'
import FieldsTime from './reports/FieldsTime'
import requests from '../requests'
import auth from '../auth'

export default {
  name: 'reports',
  data () {
    return {
      pageName: 'Reports',
      sites: [],
      clubs: [],
      displayFields: [],
      displayClubs: [],
      dateRange: [Date.now()-(24*60*60*1000), Date.now()],
      fieldNames: [],
      datePickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last 7 days',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - (7 * 24 * 60 * 60 * 1000))
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last 30 days',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - (30 * 24 * 60 * 60 * 1000))
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  beforeMount() {
    const profile = JSON.parse(auth.getProfile())
    const isSuperAdmin = profile.role == 3

    // Get the siteFields based on user role and/or client_id
    const getCorrectSiteFields = new Promise((resolve, reject) => {
      if (isSuperAdmin) {
        requests.getAllSitesFields(this, res => {
          if (res.action !== 'success') {
            return reject(res)
          }
          return resolve(res)
        })
      } else {
        requests.getSiteFields(this, profile.client_id, res => {
          if (res.action !== 'success') {
            return reject(res)
          }
          return resolve(res)
        })
      }
    })

    getCorrectSiteFields.then(res => {
      if (res.action == 'success') {
        this.sites = res.data

        // Get a list of all field ids and names; eg [{id: 1, name: "Cool field"}, {...}, etc]
        this.fieldNames = this.sites.reduce((allFieldsArray, site) => {

          allFieldsArray.push(...site.fields.reduce((perSiteArray, field) => {
            perSiteArray.push({id: field.id, name:field.field_name})
            return perSiteArray
          }, []))

          return allFieldsArray
        }, [])

      }
    }).catch(err => {
      console.error(err)
    })

    if (isSuperAdmin) {
      requests.getAllClubs(this, result => {
        this.clubs = result.data
      })
    } else {
      requests.getClubs(this, result => {
        this.clubs = result.data
      })
    }
  },
  computed: {
    formatDR() {
      if (this.dateRange.length) {
        return { from: this.dateRange[0], to: this.dateRange[1] }
      }
      return null
    },
    today() {
      return new Date()
    }
  },
  components:{
    FieldsConsumption,FieldsTime,
    LightsTable: () => import(/* webpackChunkName: "LightsTable" */ './reports/LightsTable'),
    UserActions: () => import(/* webpackChunkName: "UserActions" */ './reports/UserActions')
  }
}
</script>

<style>
  .body {
    background-color: white;
    padding: 10pt;
    overflow: hidden;
  }
  
  .highlight {
    background-color: #01809E !important;
  }
  
  .highlight a {
    color: white !important;
  }

  .el-date-editor .el-range-separator{
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// Reports.vue?69c01eb7